import { Alert, Text, Button, Group, Loader } from '@mantine/core';
import { IconAlertCircle, IconCheck, IconDownload } from '@tabler/icons-react';
import { ChromeAIStatus } from '@/types/chrome-ai';

interface ChatStatusProps {
  status: ChromeAIStatus;
  onRetry?: () => void;
  loading?: boolean;
}

export function ChatStatus({ status, onRetry, loading = false }: ChatStatusProps) {
  if (status.available) {
    return (
      <Alert 
        icon={<IconCheck size={16} />} 
        title="AI Ready" 
        color="green"
        variant="light"
      >
        <Text size="sm">Chrome's built-in AI is ready for conversation!</Text>
      </Alert>
    );
  }

  const getIcon = () => {
    if (loading) return <Loader size={16} />;
    if (status.status.includes('downloading')) return <IconDownload size={16} />;
    return <IconAlertCircle size={16} />;
  };

  const getColor = () => {
    if (status.status.includes('downloading')) return 'blue';
    return 'orange';
  };

  return (
    <Alert 
      icon={getIcon()} 
      title="Chrome AI Not Available" 
      color={getColor()}
      variant="light"
    >
      <Text size="sm" mb="xs">
        {status.status}
      </Text>
      
      {status.instructions && (
        <Text size="xs" c="dimmed" mb="md" style={{ whiteSpace: 'pre-wrap' }}>
          {status.instructions}
        </Text>
      )}

      {onRetry && !loading && (
        <Group gap="xs">
          <Button size="xs" variant="outline" onClick={onRetry}>
            Check Again
          </Button>
          <Button 
            size="xs" 
            variant="outline" 
            component="a" 
            href="chrome://flags/#prompt-api-for-gemini-nano" 
            target="_blank"
          >
            Enable AI Flags
          </Button>
        </Group>
      )}
    </Alert>
  );
}